import _ from 'lodash';

const BLOCKS_QUOTE = 'BlocksQuote';
const BLOCKS_QUOTE_RELEASE = 'BlocksQuoteRelease';

class ProducerUnderwritingIssuesCtrl {

    constructor($state, SubmissionService, FlowValidationService) {

        function withdrawSubmission() {
            const { quoteID } = this.submission.value;
            SubmissionService.withdrawSubmissionBySubmissionNumber(quoteID)
                .then(() => {
                    $state.go('quote.detail.summary', {submissionNumber: quoteID}, {custom: {skipCancelConfirmation: true}});
                });
        }

        function referToUnderwriter() {
            const { quoteID } = this.submission.value;
            SubmissionService.referToUnderwriter(quoteID, this.noteForUW)
                .then(() => {
                    $state.go('quote.detail.summary', {submissionNumber: quoteID}, {custom: {skipCancelConfirmation: true}});
                });
        }

        function approveUnderwritingIssue(uwIssue) {
            const { quoteID } = this.submission.value;
            SubmissionService.approveUnderwritingIssue(quoteID, uwIssue.originalDTO)
                .then(() => {
                    FlowValidationService.approveUnderwritingIssue(uwIssue.id);
                });
        }

        function openReferToUWForm() {
            this.referToUWFormOpen = true;
            this.noteForUW = '';
        }

        function closeReferToUWForm() {
            this.referToUWFormOpen = false;
            this.noteForUW = '';
        }

        function allUnquotable() {
            return Object.entries(this.issuesByOffering).every(([, issues]) => issues.some(offeringIssue => _.includes([BLOCKS_QUOTE, BLOCKS_QUOTE_RELEASE], offeringIssue.currentBlockingPoint)));
        }

        function isOfferingNameVisible(offeringName) {
            return !_.includes(this.anonymousOfferings, offeringName);
        }

        function areOfferingIssuesVisible(offeringName) {
            // this caters for the scenario in which we want to display the UW issues for the custom quote
            // if that's the only one we have
            return this.isOfferingNameVisible(offeringName) || _.isEmpty(this.affectedQuotes);
        }

        this.$onInit = () => {
            this.withdrawSubmission = withdrawSubmission.bind(this);
            this.referToUnderwriter = referToUnderwriter.bind(this);
            this.approveUnderwritingIssue = approveUnderwritingIssue.bind(this);
            this.openReferToUWForm = openReferToUWForm.bind(this);
            this.closeReferToUWForm = closeReferToUWForm.bind(this);
            this.isOfferingNameVisible = isOfferingNameVisible.bind(this);
            this.areOfferingIssuesVisible = areOfferingIssuesVisible.bind(this);

            this.affectedQuotes = Object.keys(this.issuesByOffering).filter(this.isOfferingNameVisible);
            this.affectedQuotesString = this.affectedQuotes.join(', ');
            this.referToUWFormOpen = false;
            this.allUnquotable = allUnquotable.call(this);
        };


    }
}

ProducerUnderwritingIssuesCtrl.$inject = ['$state', 'SubmissionService', 'FlowValidationService'];

export default ProducerUnderwritingIssuesCtrl;
